const handleShareRecipe = async (isUserCreatedRecipe: boolean) => {
  try {
    const currentUrl = window.location.href;
    const shareUrl = `${currentUrl}?source=share`;
    const shareMessage = isUserCreatedRecipe 
      ? 'I created this recipe on upliance.. check it out!' 
      : 'Check out this recipe on upliance!';

    await navigator.share({
      text: shareMessage,
      url: shareUrl,
    });
  } catch (error) {
    console.error('Error sharing:', error);
  }
};

export default handleShareRecipe;
